<section class="hero">
  <h2 class="hero__title">Funded {{ periodTitle }}</h2>
  <p class="hero__headline">
    <span class="hero__amount">{{ funded?.amount | compactCurrency }}</span>
    <span class="hero__deals">{{ funded?.deals ?? 0 | i18nPlural: dealsPlural }}</span>
  </p>
  <dl class="hero__split">
    <div class="hero__split-item">
      <dt class="hero__split-label">Activation draws</dt>
      <dd class="hero__split-value">{{ funded?.activationAmount | compactCurrency }}</dd>
    </div>
    <div class="hero__split-item">
      <dt class="hero__split-label">Residual draws</dt>
      <dd class="hero__split-value">{{ funded?.residualAmount | compactCurrency }}</dd>
    </div>
  </dl>
  <p class="hero__pace">{{ paceLine }}</p>
</section>
